import { HttpError } from '@revelio/data-access';

export class DataBuilderHttpError extends HttpError {
  constructor(
    message: string,
    status: number,
    statusText: string,
    public readonly requestId: string
  ) {
    super(message, status, statusText);
    this.name = 'DataBuilderHttpError';
  }
}
